import { HttpClient, JSON_STRING } from "../../../services/http/http-client";
import { CONTACTS_URL } from "./contacts.service";

export const CONTACT_FILE_SECTION = 'documents';

export const ContactFilesService = {
  getContactFiles: (start) => HttpClient.get(CONTACTS_URL, {
    section: CONTACT_FILE_SECTION,
    startrow: start
  }),
  getContactFilesPage: (start) => HttpClient.get(CONTACTS_URL, {
    section: CONTACT_FILE_SECTION,
    action :	"retrieve_files_page",
    tableID: 	"docs_table",
    startrow: start
  }),
  getContactFilesSearchResult: (search) => HttpClient.get(CONTACTS_URL, {
    section: CONTACT_FILE_SECTION,
    action: 'search_files',
    search
  }),
  // getContactFilesNext: (start) => HttpClient.get(CONTACTS_URL, {
  //   section: CONTACT_FILE_SECTION,
  //   action: 'retrieve_files_page',
  //   startrow: 100
  // }),

  modifyContactFileRow: (id, columnName, columnNewValue) => {
    HttpClient.modify('file_id', id, columnName, columnNewValue, 'files');
  },

  deleteContactFile: (file_id) => HttpClient.post('/files.pl', {
    action: 'delete_document',
    file_id
  }),


}